import React, { useState } from 'react';
import { newsletterAPI } from '../services/api';
import { Mail, Check } from 'lucide-react';

// variant="dark" -- for the navy footer background
// variant="light" -- for white/light card backgrounds (e.g. Podcast page)
const NewsletterSignup = ({ variant = 'light', source = 'other' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || status === 'loading') return;

    setStatus('loading');
    setErrorMsg('');
    try {
      await newsletterAPI.subscribe(email.trim(), source);
      setStatus('success');
      setEmail('');
    } catch (error) {
      setErrorMsg(error.response?.data?.email?.[0] || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  const isDark = variant === 'dark';

  if (status === 'success') {
    return (
      <div className={`flex items-center gap-2 text-sm ${isDark ? 'text-acar-gold-300' : 'text-emerald-700'}`}>
        <Check size={16} /> Subscribed -- thanks for joining.
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-sm">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail size={14} className={`absolute left-3 top-1/2 -translate-y-1/2 ${isDark ? 'text-gray-400' : 'text-gray-400'}`} />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            className={`w-full pl-8 pr-3 py-2 text-sm rounded-lg focus:outline-none focus:ring-2 ${
              isDark
                ? 'bg-gray-800 text-white placeholder-gray-500 border border-gray-700 focus:ring-acar-gold-400'
                : 'bg-white text-gray-800 border border-gray-200 focus:ring-acar-navy-500'
            }`}
          />
        </div>
        <button
          type="submit"
          disabled={status === 'loading'}
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition disabled:opacity-50 flex-shrink-0 ${
            isDark
              ? 'bg-acar-gold-600 text-white hover:bg-acar-gold-700'
              : 'bg-acar-navy-700 text-white hover:bg-acar-navy-800'
          }`}
        >
          {status === 'loading' ? '...' : 'Subscribe'}
        </button>
      </div>
      {status === 'error' && (
        <p className={`text-xs mt-1.5 ${isDark ? 'text-red-300' : 'text-red-600'}`}>{errorMsg}</p>
      )}
    </form>
  );
};

export default NewsletterSignup;
